module.exports = __webpack_public_path__ + "img/i.727f3dd4.jpg";